/**
 * Known user photo status values
 *
 * @type {Object}
 */
const UserPhotoStatusValues = {

	Unapproved: 0,

	Approved: 1,

	Review: 2,

	Rejected: -1,

	CancelledByUser: 2,

	Unknown: 99999

};

export default UserPhotoStatusValues;
